import { render, staticRenderFns } from "./kjjl.vue?vue&type=template&id=7a8d7bc8&scoped=true"
import script from "./kjjl.vue?vue&type=script&lang=js"
export * from "./kjjl.vue?vue&type=script&lang=js"
import style0 from "./kjjl.vue?vue&type=style&index=0&id=7a8d7bc8&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8d7bc8",
  null
  
)

export default component.exports